import AuthProvider from "../common/services/auth/AuthProvider/Index";

const buildResultsUrl = (serialNumber: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/v1/private/semen-analysis-kits/${serialNumber}/results`;

export const fetchResults = async (serialNumber: string): Promise<Response | null> => {
  try {
    const response = await fetch(buildResultsUrl(serialNumber), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await AuthProvider.getValidAuthorizationToken()}`,
      },
      method: "GET",
    });

    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error instanceof Error ? error : new Error("Failed to fetch results");
  }
};

export const saveResults = async (
  serialNumber: string,
  result: string
): Promise<Response | null> => {
  try {
    const response = await fetch(buildResultsUrl(serialNumber), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await AuthProvider.getValidAuthorizationToken()}`,
      },
      method: "POST",
      body: JSON.stringify({ result }),
    });

    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error instanceof Error ? error : new Error("Failed to save results");
  }
};

